import React from 'react'

import { Button } from '@st-operations/uikit/src/v2/index.js'
import Header from '../../components/header/index.jsx'
import { useHistory } from 'react-router-dom'

import PageNotFoundImg from '_static/img/page-not-found.svg'

import './styles.scss'

const PageNotFound = () => {
  const history = useHistory()
  const goToHomepage = () => {
    history.push('/')
  }
  return (
    <div className="page-not-found">
      <Header title="Page Not Found" />
      <div className="page-not-found__container">
        <h1 className="page-not-found__title">Oops! Page not found</h1>
        <p className="page-not-found__text">
          {"We can't seem to find the page you're looking for."}
        </p>
        <Button className="page-not-found__button" onClick={goToHomepage}>
          Back to Homepage
        </Button>
      </div>
      <PageNotFoundImg className="page-not-found__logo" />
    </div>
  )
}

export default React.memo(PageNotFound)
